import { FeatureCategory } from '../types';

export const socialNetworkFeatures: FeatureCategory = {
  name: "Community & Support Network",
  icon: "Users",
  features: [
    {
      name: "ThriveCircle Members",
      description: "Invite family members, friends, and caregivers to your support network. Share updates and coordinate care together in one private space.",
      starter: "1 Invite", max: "1 Invite", family: "Up to 5", careAddOn: ", "
    },
    {
      name: "Video Calls (Google Meet)",
      description: "Integrated Google Meet video calling for staying connected with family and caregivers.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "✔"
    },
    {
      name: "Video Calls (FaceTime)",
      description: "FaceTime integration for easy video calls with family members and support network.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "✔"
    },
    {
      name: "Care Coordination Dashboard",
      description: "Centralized dashboard for coordinating care activities, appointments, and communication between all care team members.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "✔"
    }
  ]
};
